import {
  Button,
  HStack,
  Image,
  Link,
  Popover,
  PopoverTrigger,
  PopoverContent,
  PopoverHeader,
  PopoverBody,
  PopoverCloseButton,
  PopoverArrow,
  Stack,
} from '@chakra-ui/react';
import { useState, useEffect, useRef } from 'react';
import WidgetsGrid from '../components/widgets_grid';
import axios from 'axios';
import { json, useNavigate } from 'react-router';
import ThemeLoad from '../components/editor_components/theme_load';
import { VStack, Text } from '@chakra-ui/react';
import { useLocation } from 'react-router';
import ImageUploadModal from '../components/image_upload';
import { useToast } from '@chakra-ui/react';
import live1 from './../assets/images/live1.webp';
const ThemeEditPage = ({ width = 540, height = 1920 }) => {
  const [images, setImages] = useState([]);
  const fetchImages = async () => {
    try {
      const response = await axios.get(
        'https://admin.i-panel.pro:8787/api/files/images'
      );
      setImages(response.data.images);
    } catch (error) {
      console.error('Error fetching images:', error);
    }
  };
  useEffect(() => {
    fetchImages();
  }, []);
  const mainBlockRef = useRef(null);
  const componentRef = useRef(null);
  const toast = useToast();

  const [image, setImage] = useState('green');
  const [resultHtml, setResultHtml] = useState('');
  const [save, setSave] = useState(false);
  const [theme, setTheme] = useState();
  function updateRootStyles(htmlString, backgroundWidgets, textColor) {
    // Создаем временный элемент для парсинга HTML строки
    const tempElement = document.createElement('div');
    tempElement.innerHTML = htmlString;

    // Ищем все теги <style> внутри временного элемента
    const styleTags = tempElement.querySelectorAll('style');

    styleTags.forEach(styleTag => {
      // Получаем содержимое тега <style>
      let styleContent = styleTag.innerHTML;

      // Проверяем, содержит ли стиль :root
      if (styleContent.includes(':root')) {
        // Обновляем содержимое стиля, удаляя старые переменные и добавляя новые
        styleContent = styleContent.replace(
          /--background-widgets:\s*[^;]+;/,
          ''
        );
        styleContent = styleContent.replace(/--text-color:\s*[^;]+;/, '');

        // Вставляем новые значения переменных в :root
        styleContent = styleContent.replace(
          /(:root\s*{)/,
          `$1 --background-widgets: ${backgroundWidgets}; --text-color: ${textColor}; `
        );

        // Обновляем содержимое текущего тега <style>
        styleTag.innerHTML = styleContent;
      }
    });

    // Возвращаем обновленный HTML как строку
    return tempElement.innerHTML;
  }
  // function updatePositionInHTML(innerHTML, newTop, newLeft) {
  //   // Создаем элемент для парсинга HTML
  //   const parser = new DOMParser();
  //   const doc = parser.parseFromString(innerHTML, 'text/html');

  //   // Находим все теги <style>
  //   const styleTags = doc.querySelectorAll('style');

  //   // Регулярные выражения для поиска и удаления
  //   const positionRegex = /position:\s*absolute\s*;/i;
  //   const topBottomRegex = /(top|bottom):\s*\d+px\s*(?:!important)?;?/gi;
  //   const leftRightRegex = /(left|right):\s*\d+px\s*(?:!important)?;?/gi;

  //   for (const styleTag of styleTags) {
  //     let styleContent = styleTag.textContent;

  //     // Проверяем наличие 'position: absolute;'
  //     if (positionRegex.test(styleContent)) {
  //       // Удаляем 'bottom' и 'right'
  //       styleContent = styleContent.replace(/(bottom|right):\s*\d+px\s*(?:!important)?;?/gi, '');

  //       // Обновляем или добавляем 'top' и 'left'
  //       if (!/(top:\s*\d+px\s*(?:!important)?;?)/gi.test(styleContent)) {
  //         styleContent += `top: ${newTop}px !important; `;
  //       } else {
  //         styleContent = styleContent.replace(/top:\s*\d+px\s*(?:!important)?;?/gi, `top: ${newTop}px !important;`);
  //       }

  //       if (!/(left:\s*\d+px\s*(?:!important)?;?)/gi.test(styleContent)) {
  //         styleContent += `left: ${newLeft}px !important; `;
  //       } else {
  //         styleContent = styleContent.replace(/left:\s*\d+px\s*(?:!important)?;?/gi, `left: ${newLeft}px !important;`);
  //       }

  //       // Обновляем содержимое стиля
  //       styleTag.textContent = styleContent;
  //     }
  //   }

  //   // Возвращаем обновленный HTML в виде строки
  //   return doc.body.innerHTML;
  // }

  function updatePositionInHTML(innerHTML, newTop, newLeft) {
    // Создаем элемент для парсинга HTML
    const parser = new DOMParser();
    const doc = parser.parseFromString(innerHTML, 'text/html');

    // Находим все теги <style>
    const styleTags = doc.querySelectorAll('style');

    // Обрабатываем каждый <style> тег
    for (const styleTag of styleTags) {
      const styleSheet = new CSSStyleSheet();
      styleSheet.replaceSync(styleTag.textContent);

      // Обрабатываем все правила стиля
      for (const rule of styleSheet.cssRules) {
        if (rule.selectorText && rule.selectorText.includes('.')) {
          const cssRules = rule.style;
          if (cssRules.position === 'absolute') {
            // Удаляем свойства bottom и right
            cssRules.removeProperty('bottom');
            cssRules.removeProperty('right');

            // Устанавливаем свойства top и left
            cssRules.setProperty('top', `${newTop}px`, 'important');
            cssRules.setProperty('left', `${newLeft}px`, 'important');
          } else if (
            rule.selectorText.includes('widget') &&
            !rule.selectorText.includes(' ') &&
            !rule.selectorText.includes('>') &&
            !rule.selectorText.includes('<')
          ) {
            cssRules.setProperty('position', 'absolute');
            cssRules.setProperty('top', `${newTop}px`, 'important');
            cssRules.setProperty('left', `${newLeft}px`, 'important');
          }
        }
      }

      // Обновляем содержимое тега <style>
      styleTag.textContent = [...styleSheet.cssRules]
        .map(rule => rule.cssText)
        .join('\n');
    }

    // Возвращаем обновленный HTML в виде строки
    return doc.body.innerHTML;
  }

  // Пример использования:
  // const updatedHtml = updateRootStyles(htmlString, '#ff0000', '#000000');

  useEffect(() => {
    if (componentRef.current && mainBlockRef.current) {
      const rect1 = componentRef.current.getBoundingClientRect();
      const rect2 = mainBlockRef.current.getBoundingClientRect();

      console.log(rect1, rect2);
      console.log(rect1.x - rect2.x, rect1.y - rect2.y);
    }
  }, [componentRef, mainBlockRef]);
  useEffect(() => {
    let timer1 = () => {};
    if (save) {
      timer1 = setTimeout(() => {
        setSave(false);
      }, 5000);
    }
    return () => {
      clearTimeout(timer1);
    };
  }, [save]);
  const navigate = useNavigate();
  useEffect(() => {
    console.log(resultHtml);
  }, [resultHtml]);
  const scrollToElement = (targetId, overflowElementId) => {
    // Прокрутка страницы по вертикали до целевого элемента
    const targetElement = document.getElementById(targetId);
    if (targetElement) {
      targetElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }

    // Прокрутка элемента с overflow по горизонтали до целевого элемента
    const overflowElement = document.getElementById(overflowElementId);
    if (overflowElement) {
      const targetRect = targetElement.getBoundingClientRect();
      const overflowRect = overflowElement.getBoundingClientRect();

      const scrollLeft =
        targetRect.left - overflowRect.left + overflowElement.scrollLeft;
      overflowElement.scrollTo({ left: scrollLeft, behavior: 'smooth' });
    }
  };
  const location = useLocation();
  const widgetsRef = useRef();
  return (
    <VStack
      width={'100%'}
      align={'flex-start'}
      userSelect={'none'}
      unselectable="on"
    >
      <Stack
        width={'100%'}
        align={'flex-start'}
        justify={'flex-start'}
        direction={
          location.state.width > location.state.height ? 'column' : 'row'
        }
      >
        <VStack
          width={location.state.width}
          height={location.state.height}
          minWidth={location.state.width}
          minHeight={location.state.height}
          border="2px solid yellow"
          ref={mainBlockRef}
          className="suka"
          backgroundSize={'cover'}
          objectFit={'contain'}
          position={'relative'}
        >
          <div
            // backgroundSize={'cover'}
            // objectFit={'contain'}

            // top={0}
            // left={0}
            // width={'100%'}
            // height={'100%'}
            // backgroundImage={image}
            id="workspace"
            style={{
              position: 'relative',
              width: location.state.width,
              height: location.state.height,
              backgroundImage: `url()`,
              backgroundSize: 'cover',
            }}
            ref={widgetsRef}
          >
            {theme}
          </div>
          {/* ) : (
            <video
              style={{
                position: 'absolute',
                top: 0,
                left: 0,
                width: '100%',
                height: '100%',
                objectFit: 'cover',
              }}
              autoPlay
              loop
              muted
            >
              <source src={image} type="video/mp4" />
              Your browser does not support the video tag.
            </video>
          )} */}

          {/* <Draggable
        // onStop={(e, data) => console.log(e, data)}
        >
          <div ref={componentRef}>
            <h1>привет</h1>
          </div>
        </Draggable> */}
        </VStack>
        <VStack
          fontSize={24}
          // width={'600px'}
          paddingLeft={'20px'}
          align={'flex-start'}
          alignSelf={'flex-start'}
        >
          <HStack
            backgroundImage={live1}
            onClick={() => {
              console.log(image);
              let workspace = document.getElementById('workspace');
              workspace.style.backgroundImage = live1;
              workspace.style.backgroundColor = ``;
            }}
          >
            <Text>Выбор обоев</Text>{' '}
            <Link color={'#32309E'}>или загрузить свои</Link>
            <ImageUploadModal uploadAgain={fetchImages} />
          </HStack>
          <HStack width={'100%'} spacing={'20px'} overflowX={'scroll'}>
            {images.map((image, index) => (
              <Image
                key={index}
                src={`https://admin.i-panel.pro:8787${image}`}
                alt={`Uploaded image ${index + 1}`}
                onClick={() => {
                  console.log(image);
                  let workspace = document.getElementById('workspace');
                  workspace.style.backgroundImage = `url(https://admin.i-panel.pro:8787${image})`;
                  workspace.style.backgroundColor = ``;
                }}
                width={width * 0.2}
                height={height * 0.2}
                objectFit={'cover'}
              />
            ))}

            {/* <Image
              src={oboi4}
              onClick={() => setImage(oboi4)}
              width={width * 0.2}
              height={height * 0.2}
              objectFit={'cover'}
            />{' '} */}
          </HStack>
          {/* <Text>Выбор живых обоев</Text>
          <HStack width={'900px'} spacing={'20px'} overflowX={'scroll'}>
            <Image
              src={video1}
              onClick={() => {
                setImage(
                  'https://admin.i-panel.pro:8787/static/Realistic_Abstracts_03.mp4'
                );
                setIsVideo(true);
              }}
              width={width * 0.2}
              height={height * 0.2}
              objectFit={'cover'}
            />{' '}
          </HStack> */}
          <ThemeLoad
            parentRef={mainBlockRef}
            setTheme={setTheme}
            widgetsRef={widgetsRef}
            orient={
              location.state.width > location.state.height
                ? 'horizontal'
                : 'vertical'
            }
            width={location.state.width}
            height={location.state.height}
            fabric_number={location.state.fabric_number}
            mainBlockRef={mainBlockRef}
          />
          {/* <Text>Создать виджет</Text>
          <CreateWidget parentRef={mainBlockRef} /> */}
        </VStack>
      </Stack>
      <HStack
        position={'fixed'}
        top={0}
        left={0}
        borderBottomRadius={'16px'}
        border={'2px solid #4945FF'}
        padding={'5px 10px'}
        zIndex={999999}
        backgroundColor={'#181826'}
        cursor={'pointer'}
        _hover={{
          border: '2px solid #181826',
          backgroundColor: '#4945FF',
        }}
        onClick={() => {
          let iframe = document.getElementById('workSpaceFrame');
          iframe.parentNode.removeChild(iframe);
          navigate('/main');
        }}
      >
        <Text>Выйти в главное меню</Text>
      </HStack>

      <HStack
        position={'fixed'}
        bottom={0}
        right={0}
        zIndex={999999}
        width={'100vw'}
        align={'flex-end'}
      >
        <Popover>
          <PopoverTrigger>
            <HStack
              borderTopRadius={'16px'}
              border={'2px solid #4945FF'}
              padding={'5px 10px'}
              zIndex={999999}
              backgroundColor={'#181826'}
              cursor={'pointer'}
              _hover={{
                border: '2px solid #181826',
                backgroundColor: '#4945FF',
              }}
            >
              <Text>Аналоговые часы</Text>
            </HStack>
          </PopoverTrigger>
          <PopoverContent
            zIndex={999999}
            backgroundColor={'#181826'}
            borderColor={'#4945FF'}
          >
            <PopoverArrow />
            <PopoverCloseButton />
            <PopoverBody>
              <VStack align="start" color={'white'}>
                <Button
                  variant="ghost"
                  width="100%"
                  color={'white'}
                  onClick={() => scrollToElement('analog', 'widgets_overflow')}
                >
                  1
                </Button>
              </VStack>
            </PopoverBody>
          </PopoverContent>
        </Popover>
        <Popover>
          <PopoverTrigger>
            <HStack
              borderTopRadius={'16px'}
              border={'2px solid #4945FF'}
              padding={'5px 10px'}
              zIndex={999999}
              backgroundColor={'#181826'}
              cursor={'pointer'}
              _hover={{
                border: '2px solid #181826',
                backgroundColor: '#4945FF',
              }}
            >
              <Text>Цифровые часы</Text>
            </HStack>
          </PopoverTrigger>
          <PopoverContent
            zIndex={999999}
            backgroundColor={'#181826'}
            borderColor={'#4945FF'}
          >
            <PopoverArrow />
            <PopoverCloseButton />
            <PopoverHeader borderColor={'#4945FF'}>
              Выберите размер
            </PopoverHeader>
            <PopoverBody>
              <VStack align="start" color={'white'}>
                <Button
                  variant="ghost"
                  width="100%"
                  color={'white'}
                  onClick={() =>
                    scrollToElement('digitalClockXL', 'widgets_overflow')
                  }
                >
                  XL
                </Button>
                <Button
                  variant="ghost"
                  width="100%"
                  color={'white'}
                  onClick={() =>
                    scrollToElement('digitalClockL', 'widgets_overflow')
                  }
                >
                  L
                </Button>
                <Button
                  variant="ghost"
                  width="100%"
                  color={'white'}
                  onClick={() =>
                    scrollToElement('digitalClockM', 'widgets_overflow')
                  }
                >
                  M
                </Button>
                <Button
                  variant="ghost"
                  width="100%"
                  color={'white'}
                  onClick={() =>
                    scrollToElement('digitalClockS', 'widgets_overflow')
                  }
                >
                  S
                </Button>
              </VStack>
            </PopoverBody>
          </PopoverContent>
        </Popover>
        <Popover>
          <PopoverTrigger>
            <HStack
              borderTopRadius={'16px'}
              border={'2px solid #4945FF'}
              padding={'5px 10px'}
              zIndex={999999}
              backgroundColor={'#181826'}
              cursor={'pointer'}
              _hover={{
                border: '2px solid #181826',
                backgroundColor: '#4945FF',
              }}
            >
              <Text>Календари</Text>
            </HStack>
          </PopoverTrigger>
          <PopoverContent
            zIndex={999999}
            backgroundColor={'#181826'}
            borderColor={'#4945FF'}
          >
            <PopoverArrow />
            <PopoverCloseButton />
            <PopoverHeader borderColor={'#4945FF'}>
              Выберите размер
            </PopoverHeader>
            <PopoverBody>
              <VStack align="start" color={'white'}>
                <Button
                  variant="ghost"
                  width="100%"
                  color={'white'}
                  onClick={() =>
                    scrollToElement('calendarsXL', 'widgets_overflow')
                  }
                >
                  XL
                </Button>
                <Button
                  variant="ghost"
                  width="100%"
                  color={'white'}
                  onClick={() =>
                    scrollToElement('calendarsL', 'widgets_overflow')
                  }
                >
                  L
                </Button>
                <Button
                  variant="ghost"
                  width="100%"
                  color={'white'}
                  onClick={() =>
                    scrollToElement('calendarsM', 'widgets_overflow')
                  }
                >
                  M
                </Button>
                <Button
                  variant="ghost"
                  width="100%"
                  color={'white'}
                  onClick={() =>
                    scrollToElement('calendarsS', 'widgets_overflow')
                  }
                >
                  S
                </Button>
                <Button
                  variant="ghost"
                  width="100%"
                  color={'white'}
                  onClick={() =>
                    scrollToElement('calendarsXS', 'widgets_overflow')
                  }
                >
                  XS
                </Button>
              </VStack>
            </PopoverBody>
          </PopoverContent>
        </Popover>
        <Popover>
          <PopoverTrigger>
            <HStack
              borderTopRadius={'16px'}
              border={'2px solid #4945FF'}
              padding={'5px 10px'}
              zIndex={999999}
              backgroundColor={'#181826'}
              cursor={'pointer'}
              _hover={{
                border: '2px solid #181826',
                backgroundColor: '#4945FF',
              }}
            >
              <Text>Погода</Text>
            </HStack>
          </PopoverTrigger>
          <PopoverContent
            zIndex={999999}
            backgroundColor={'#181826'}
            borderColor={'#4945FF'}
          >
            <PopoverArrow />
            <PopoverCloseButton />
            <PopoverHeader borderColor={'#4945FF'}>
              Выберите размер
            </PopoverHeader>
            <PopoverBody>
              <VStack align="start" color={'white'}>
                <Button
                  variant="ghost"
                  width="100%"
                  color={'white'}
                  onClick={() =>
                    scrollToElement('weatherXL', 'widgets_overflow')
                  }
                >
                  XL
                </Button>
                <Button
                  variant="ghost"
                  width="100%"
                  color={'white'}
                  onClick={() =>
                    scrollToElement('weatherL', 'widgets_overflow')
                  }
                >
                  L
                </Button>
                <Button
                  variant="ghost"
                  width="100%"
                  color={'white'}
                  onClick={() =>
                    scrollToElement('weatherM', 'widgets_overflow')
                  }
                >
                  M
                </Button>
                <Button
                  variant="ghost"
                  width="100%"
                  color={'white'}
                  onClick={() =>
                    scrollToElement('weatherS', 'widgets_overflow')
                  }
                >
                  S
                </Button>
                <Button
                  variant="ghost"
                  width="100%"
                  color={'white'}
                  onClick={() =>
                    scrollToElement('weatherXS', 'widgets_overflow')
                  }
                >
                  XS
                </Button>
              </VStack>
            </PopoverBody>
          </PopoverContent>
        </Popover>
        <Popover>
          <PopoverTrigger>
            <HStack
              borderTopRadius={'16px'}
              border={'2px solid #4945FF'}
              padding={'5px 10px'}
              zIndex={999999}
              backgroundColor={'#181826'}
              cursor={'pointer'}
              _hover={{
                border: '2px solid #181826',
                backgroundColor: '#4945FF',
              }}
            >
              <Text>Пробки</Text>
            </HStack>
          </PopoverTrigger>
          <PopoverContent
            zIndex={999999}
            backgroundColor={'#181826'}
            borderColor={'#4945FF'}
          >
            <PopoverArrow />
            <PopoverCloseButton />
            <PopoverHeader borderColor={'#4945FF'}>
              Выберите размер
            </PopoverHeader>
            <PopoverBody>
              <VStack align="start" color={'white'}>
                <Button
                  variant="ghost"
                  width="100%"
                  color={'white'}
                  onClick={() =>
                    scrollToElement('trafficXL', 'widgets_overflow')
                  }
                >
                  XL
                </Button>
                <Button
                  variant="ghost"
                  width="100%"
                  color={'white'}
                  onClick={() =>
                    scrollToElement('trafficL', 'widgets_overflow')
                  }
                >
                  L
                </Button>
                <Button
                  variant="ghost"
                  width="100%"
                  color={'white'}
                  onClick={() =>
                    scrollToElement('trafficM', 'widgets_overflow')
                  }
                >
                  M
                </Button>
                <Button
                  variant="ghost"
                  width="100%"
                  color={'white'}
                  onClick={() =>
                    scrollToElement('trafficS', 'widgets_overflow')
                  }
                >
                  S
                </Button>
                <Button
                  variant="ghost"
                  width="100%"
                  color={'white'}
                  onClick={() =>
                    scrollToElement('trafficXS', 'widgets_overflow')
                  }
                >
                  XS
                </Button>

                {/* <Button variant="ghost" width="100%" color={'white'}>
                  XL
                </Button> */}
              </VStack>
            </PopoverBody>
          </PopoverContent>
        </Popover>
        <Popover>
          <PopoverTrigger>
            <HStack
              borderTopRadius={'16px'}
              border={'2px solid #4945FF'}
              padding={'5px 10px'}
              zIndex={999999}
              backgroundColor={'#181826'}
              cursor={'pointer'}
              _hover={{
                border: '2px solid #181826',
                backgroundColor: '#4945FF',
              }}
            >
              <Text>Новости</Text>
            </HStack>
          </PopoverTrigger>
          <PopoverContent
            zIndex={999999}
            backgroundColor={'#181826'}
            borderColor={'#4945FF'}
          >
            <PopoverArrow />
            <PopoverCloseButton />
            <PopoverBody>
              <VStack align="start" color={'white'}>
                <Button
                  variant="ghost"
                  width="100%"
                  color={'white'}
                  onClick={() => scrollToElement('news1', 'widgets_overflow')}
                >
                  1
                </Button>
              </VStack>
            </PopoverBody>
          </PopoverContent>
        </Popover>
        <Popover>
          <PopoverTrigger>
            <HStack
              borderTopRadius={'16px'}
              border={'2px solid #4945FF'}
              padding={'5px 10px'}
              zIndex={999999}
              backgroundColor={'#181826'}
              cursor={'pointer'}
              _hover={{
                border: '2px solid #181826',
                backgroundColor: '#4945FF',
              }}
            >
              <Text>Курс валют</Text>
            </HStack>
          </PopoverTrigger>
          <PopoverContent
            zIndex={999999}
            backgroundColor={'#181826'}
            borderColor={'#4945FF'}
          >
            <PopoverArrow />
            <PopoverCloseButton />
            <PopoverHeader borderColor={'#4945FF'}>
              Выберите размер
            </PopoverHeader>
            <PopoverBody>
              <VStack align="start" color={'white'}>
                <Button
                  variant="ghost"
                  width="100%"
                  color={'white'}
                  onClick={() =>
                    scrollToElement('courseXL', 'widgets_overflow')
                  }
                >
                  XL
                </Button>
                <Button
                  variant="ghost"
                  width="100%"
                  color={'white'}
                  onClick={() => scrollToElement('courseL', 'widgets_overflow')}
                >
                  L
                </Button>
                <Button
                  variant="ghost"
                  width="100%"
                  color={'white'}
                  onClick={() => scrollToElement('courseM', 'widgets_overflow')}
                >
                  M
                </Button>
                <Button
                  variant="ghost"
                  width="100%"
                  color={'white'}
                  onClick={() => scrollToElement('courseS', 'widgets_overflow')}
                >
                  S
                </Button>
                <Button
                  variant="ghost"
                  width="100%"
                  color={'white'}
                  onClick={() =>
                    scrollToElement('courseXS', 'widgets_overflow')
                  }
                >
                  XS
                </Button>

                {/* <Button variant="ghost" width="100%" color={'white'}>
                  XL
                </Button> */}
              </VStack>
            </PopoverBody>
          </PopoverContent>
        </Popover>

        <Popover>
          <PopoverTrigger>
            <HStack
              borderTopRadius={'16px'}
              border={'2px solid #4945FF'}
              padding={'5px 10px'}
              zIndex={999999}
              backgroundColor={'#181826'}
              cursor={'pointer'}
              _hover={{
                border: '2px solid #181826',
                backgroundColor: '#4945FF',
              }}
            >
              <Text>Металлы</Text>
            </HStack>
          </PopoverTrigger>
          <PopoverContent
            zIndex={999999}
            backgroundColor={'#181826'}
            borderColor={'#4945FF'}
          >
            <PopoverArrow />
            <PopoverCloseButton />
            <PopoverHeader borderColor={'#4945FF'}>
              Выберите размер
            </PopoverHeader>
            <PopoverBody>
              <VStack align="start" color={'white'}>
                <Button
                  variant="ghost"
                  width="100%"
                  color={'white'}
                  onClick={() =>
                    scrollToElement('metalsXL', 'widgets_overflow')
                  }
                >
                  XL
                </Button>
                <Button
                  variant="ghost"
                  width="100%"
                  color={'white'}
                  onClick={() => scrollToElement('metalsL', 'widgets_overflow')}
                >
                  L
                </Button>
                <Button
                  variant="ghost"
                  width="100%"
                  color={'white'}
                  onClick={() => scrollToElement('metalsM', 'widgets_overflow')}
                >
                  M
                </Button>
                <Button
                  variant="ghost"
                  width="100%"
                  color={'white'}
                  onClick={() => scrollToElement('metalsS', 'widgets_overflow')}
                >
                  S
                </Button>
              </VStack>
            </PopoverBody>
          </PopoverContent>
        </Popover>

        <HStack
          borderTopRadius={'16px'}
          border={'2px solid #4945FF'}
          padding={'5px 10px'}
          zIndex={999999}
          backgroundColor={'#181826'}
          onClick={() => scrollToElement('about', 'widgets_overflow')}
          cursor={'pointer'}
          _hover={{
            border: '2px solid #181826',
            backgroundColor: '#4945FF',
          }}
        >
          <Text>Инфо о нас</Text>
        </HStack>
        <Popover>
          <PopoverTrigger>
            <HStack
              borderTopRadius={'16px'}
              border={'2px solid #4945FF'}
              padding={'5px 10px'}
              zIndex={999999}
              backgroundColor={'#181826'}
              cursor={'pointer'}
              _hover={{
                border: '2px solid #181826',
                backgroundColor: '#4945FF',
              }}
            >
              <Text>Музыка</Text>
            </HStack>
          </PopoverTrigger>
          <PopoverContent
            zIndex={999999}
            backgroundColor={'#181826'}
            borderColor={'#4945FF'}
          >
            <PopoverArrow />
            <PopoverCloseButton />
            <PopoverHeader borderColor={'#4945FF'}>
              Выберите размер
            </PopoverHeader>
            <PopoverBody>
              <VStack align="start" color={'white'}>
                <Button
                  variant="ghost"
                  width="100%"
                  color={'white'}
                  onClick={() => scrollToElement('musicL', 'widgets_overflow')}
                >
                  L
                </Button>
                <Button
                  variant="ghost"
                  width="100%"
                  color={'white'}
                  onClick={() => scrollToElement('musicM', 'widgets_overflow')}
                >
                  M
                </Button>
                <Button
                  variant="ghost"
                  width="100%"
                  color={'white'}
                  onClick={() => scrollToElement('musicS', 'widgets_overflow')}
                >
                  S
                </Button>
              </VStack>
            </PopoverBody>
          </PopoverContent>
        </Popover>

        <HStack
          borderTopRadius={'16px'}
          border={'2px solid #4945FF'}
          padding={'5px 10px'}
          zIndex={999999}
          backgroundColor={'white'}
          cursor={'pointer'}
          color={'#181826'}
          onClick={async () => {
            setResultHtml('');
            let grids = document.getElementsByClassName('react-draggable');
            let buffer = '';
            for (let elem of grids) {
              console.log(elem);

              if (elem.classList.contains('react-draggable')) {
                let elementRect = '';
                try {
                  elementRect = elem.getBoundingClientRect();
                } catch {
                  console.log(elem);
                }
                let parentRect = mainBlockRef.current.getBoundingClientRect();
                const isWithinParent =
                  elementRect.top >= parentRect.top &&
                  elementRect.left >= parentRect.left &&
                  elementRect.bottom <= parentRect.bottom &&
                  elementRect.right <= parentRect.right;
                if (isWithinParent) {
                  if (
                    Array.from(elem.children).filter(node =>
                      node.classList.contains(
                        'design-1',
                        'design-2',
                        'design-3',
                        'design-4',
                        'design-5',
                        'design-6',
                        'design-7',
                        'design-8',
                        'design-9'
                      )
                    ).length != 0
                  ) {
                    let inner = Array.from(elem.children).filter(node =>
                      node.classList.contains(
                        'design-1',
                        'design-2',
                        'design-3',
                        'design-4',
                        'design-5',
                        'design-6',
                        'design-7',
                        'design-8',
                        'design-9'
                      )
                    );
                    console.log(inner);
                    let position = {
                      x: elementRect.left - parentRect.left,
                      y: elementRect.top - parentRect.top,
                    };
                    const styles = window.getComputedStyle(elem.parentElement);
                    const backgroundWidgets = styles.getPropertyValue(
                      '--background-widgets'
                    );

                    const textColor = styles.getPropertyValue('--text-color');
                    console.log(backgroundWidgets, textColor);
                    buffer += `<div class="${elem.classList} ${
                      inner[0].classList
                    }" style="position: absolute !important; top: ${Math.round(
                      position.y
                    )}px !important; left: ${Math.round(
                      position.x
                    )}px !important; --background-widgets: ${backgroundWidgets} !important; --text-color: ${textColor} !important;">${updatePositionInHTML(
                      updateRootStyles(
                        inner[0].innerHTML,
                        backgroundWidgets,
                        textColor
                      ),
                      Math.round(position.y),
                      Math.round(position.x)
                    )}</div>`;
                  } else {
                    let position = {
                      x: elementRect.left - parentRect.left,
                      y: elementRect.top - parentRect.top,
                    };
                    const styles = window.getComputedStyle(elem.parentElement);
                    const backgroundWidgets = styles.getPropertyValue(
                      '--background-widgets'
                    );
                    const textColor = styles.getPropertyValue('--text-color');
                    console.log(backgroundWidgets, textColor);
                    buffer += `<div class="${
                      elem.classList
                    }" style="position: absolute !important; top: ${Math.round(
                      position.y
                    )}px !important; left: ${Math.round(
                      position.x
                    )}px !important; --background-widgets: ${backgroundWidgets} !important; --text-color: ${textColor} !important;">${updatePositionInHTML(
                      updateRootStyles(
                        elem.innerHTML,
                        backgroundWidgets,
                        textColor
                      ),
                      Math.round(position.y),
                      Math.round(position.x)
                    )}</div>`;
                  }
                }
              }
            }
            console.log(buffer);

            // Установите HTML как результат
            setResultHtml(
              `<div class="container" style="width:${
                location.state.width
              }px; height:${
                location.state.height
              }px;">${buffer}</div> <style>.container{
               background-image:${
                 document.getElementById('workspace').style.backgroundImage
                   ? document.getElementById('workspace').style.backgroundImage
                   : 'none'
               }; background-color:${
                document.getElementById('workspace').style.backgroundColor
                  ? document.getElementById('workspace').style.backgroundColor
                  : 'none'
              };
              }</style>`
            );
            let theme = `<div class="container" style="width:${
              location.state.width
            }px; height:${location.state.height}px;"><script>const panelId = ${
              location.state.panel_id
            };</script>${buffer}</div>  <style>.container{
               background-image:${
                 document.getElementById('workspace').style.backgroundImage
                   ? document.getElementById('workspace').style.backgroundImage
                   : 'none'
               }; background-color:${
              document.getElementById('workspace').style.backgroundColor
                ? document.getElementById('workspace').style.backgroundColor
                : 'none'
            };
            background-size: cover;
              }</style>`;
            console.log(
              document.getElementById('workspace').style.backgroundColor,
              document.getElementById('workspace').style.backgroundImage
            );
            console.log(theme);

            // URL-энкодируем HTML-код и вставляем его в query параметр
            const encodedHtml = encodeURIComponent(resultHtml);

            // Отправьте результат на сервер
            try {
              const response = await fetch(
                `https://admin.i-panel.pro:8787/api/panels/update_panel_theme/${location.state.fabric_number}`,
                {
                  method: 'POST',
                  headers: {
                    'Content-Type': 'application/json',
                  },
                  body: JSON.stringify({ theme: theme }), // Тело запроса пустое, так как HTML передается через query параметр
                }
              );
              const data = await response.json();
              console.log('Server response:', data);
              toast({
                title: 'Тема успешно обновлена.',
                status: 'success',
                duration: 3000,
                isClosable: true,
                position: 'top',
              });
            } catch (error) {
              console.error('Error sending request:', error);
              toast({
                title: 'Ошибка обновления',
                status: 'error',
                description:
                  'Что-то пошло не так. Пожалуйста, попробуйте снова.',
                duration: 5000,
                isClosable: true,
                position: 'top',
              });
            }
          }}
        >
          <Text>Сохранить</Text>
        </HStack>
      </HStack>

      <WidgetsGrid
        parentRef={mainBlockRef}
        save={save}
        setSave={setSave}
        resultHtml={resultHtml}
        setResultHtml={setResultHtml}
      />
    </VStack>
  );
};

export default ThemeEditPage;
